// Graphics: storyboards from a sentence (built in the demiurge repo, served as static files from
// /graphics-app/). Signed-in users only: this route is under /app/ (HeaderBar sends signed-out
// visitors to /accessRequired), and the framed tool gets the API root and a fresh access token
// from this page for every request (the backend's /api/graphics checks it).
import React, { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const GraphicsPage = () => {
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const frame = useRef(null);

  useEffect(() => {
    async function onMessage(e) {
      if (e.origin !== window.location.origin || !e.data || e.data.type !== 'graphics:token-request') return;
      if (!frame.current || e.source !== frame.current.contentWindow) return;
      let token = '';
      try {
        token = isAuthenticated ? await getAccessTokenSilently() : '';
      } catch {
        token = '';
      }
      frame.current.contentWindow.postMessage(
        { type: 'graphics:token', api: process.env.REACT_APP_API_URL, token },
        window.location.origin
      );
    }
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [isAuthenticated, getAccessTokenSilently]);

  if (isLoading) return null;
  if (!isAuthenticated) {
    // (HeaderBar redirects signed-out visitors on /app/ pages, except on demo and localhost hosts)
    return (
      <div className="Page" style={{ textAlign: 'center', paddingTop: 80 }}>
        <h2>Graphics</h2>
        <p>Sign in to make storyboards from a sentence.</p>
        <a className="button" href="/login">Sign in</a>
      </div>
    );
  }
  return (
    <iframe
      ref={frame}
      title="Graphics"
      src="/graphics-app/index.html"
      style={{ display: 'block', width: '100%', height: 'calc(100vh - 65px)', border: 0 }}
    />
  );
};

export default GraphicsPage;
